import {useMutation, UseMutationOptions, useQueryClient,} from '@tanstack/react-query';
import {GenerationResultDto} from '@tinct/core-api-models';
import {ApiError, tinctApi} from '../../api';

export interface GenerateAllParams {
  id: string;
  organizationId: string;
}

export const generateAll = async (params: GenerateAllParams): Promise<GenerationResultDto> => {
  return await tinctApi.campaigns.generateAll(params.id);
};

export const useGenerateAll = (
  options?: Omit<
    UseMutationOptions<GenerationResultDto, ApiError, GenerateAllParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: generateAll,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', args[1].id] });
      queryClient.invalidateQueries({ queryKey: ['organization', args[1].organizationId] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};